const ASSESSMENT_FIELDS = 'id, booking_id, first_pass, appearance, red_flags, communication, personality, overall, assessed_at, assessed_by';

const LIST_INTERVIEW_FIELDS = `id, member_id, starts_at, canceled_at, no_show_at, completed_at, allowed_channels, meeting_url, created_at, interview_assessments(${ASSESSMENT_FIELDS})`;

const BOOKING_APPLICANT_FIELDS = 'first_name, ...user_private!inner(last_name), ...user_state!inner(role, status)';

const CONCIERGE_SESSION_FIELDS = 'id, member_id, starts_at, completed_at, end_reason';

const INTRO_CALL_KIND = 'intro_call';

const HELD_SESSION_FILTER = 'end_reason.is.null,end_reason.eq.completed';

const COMPLETED_END_REASON = 'completed';

const CANCEL_EVENT_PATH = '/interview-cancel';

const SEARCH_BOOKING_COLUMNS = ['first_name', 'last_name'] as const;

const STAFF_INTERVIEW_FIELDS = `id, member_id, starts_at, canceled_at, no_show_at, completed_at, interviewer_id, kind, interview_assessments(id), applicant:users!interview_bookings_member_id_fkey(${BOOKING_APPLICANT_FIELDS})`;

export {
  ASSESSMENT_FIELDS,
  CANCEL_EVENT_PATH,
  COMPLETED_END_REASON,
  CONCIERGE_SESSION_FIELDS,
  HELD_SESSION_FILTER,
  INTRO_CALL_KIND,
  BOOKING_APPLICANT_FIELDS,
  LIST_INTERVIEW_FIELDS,
  SEARCH_BOOKING_COLUMNS,
  STAFF_INTERVIEW_FIELDS,
};
